export default "<input type=\"file\" #fileInput placeholder=\"Upload file...\" (change)=\"upload()\" accept=\".xls,.xlsx,.ods\"/>\r\n";